<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.files_and_reports") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="onToggleDialog" class="primary">
        <span>{{ $t("button.create") }}</span>
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      ref="table_ref"
      :headersName="headers"
      pathName="files"
      class="table-row"
      dialogWidth="500"
    >
      <template v-slot="{ item, index }">
        <td class="text-sm-center">
          <a :href="item.attachment.path" target="_blank">
            <img
              width="40px"
              height="40px"
              :src="require('@/assets/imgs/pdf.png')"
              alt="pdf file"
            />
          </a>
        </td>
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ $t(`labels.${item.title}`) }}</td>

        <td class="text-sm-center">
          <v-icon
            @click="handleEdit(item, index)"
            :title="$t('icon.edit')"
            small
            >mdi-pencil</v-icon
          >
          <v-icon
            :title="$t('icon.delete')"
            @click="handleDelete(item, index)"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
        <v-card-text class="pt-4">
          <form-wrapper :validator="$v.form">
            <v-form @submit.prevent="handleSubmit">
              <locale-select v-if="isEdit" @change="onLocaleChange" />
              <form-group name="title">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.title"
                    :items="items"
                    item-text="key"
                    item-value="value"
                    outlined
                  ></v-select>
                </template>
              </form-group>
              <form-group name="name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.name"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
              <fileUpload
                :reset="reset"
                @ImageUpdated="handelRefreshData"
                @fileSelected="onFileSelected"
                :locale="locale"
                :file_url="attachment"
                :file_id="form.attachment && form.attachment.id"
                class="file-upload__image"
                :maxSize="maxsize"
              />
              <v-col cols="12" class="mx-auto pa-0">
                <v-alert
                  type="error"
                  v-if="serverErrors && serverErrors['attachment']"
                  >{{ serverErrors["attachment"][0] }}</v-alert
                >
              </v-col>

              <div style="margin-top: 50px"></div>
              <v-btn
                large
                :loading="loading"
                :disabled="$v.form.$invalid"
                block
                class="primary my-5"
                type="submit"
                >{{ $t("button.save") }} <v-icon>mdi-save</v-icon></v-btn
              >
            </v-form>
          </form-wrapper>
        </v-card-text>
      </template>
      <!-- dilaog -->
    </wrapping-table>
  </main>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import cookie from "js-cookie";
import { ShowData } from "@/helpers/apiMethods";
export default {
  name: "FilesAndReports",
  components: {
    fileUpload: () => import("@/components/fileUpload"),
  },
  data() {
    return {
      maxsize: 2045,
      loading: false,
      items: [
        { key: this.$t("labels.model_data"), value: "model_data" },
        {
          key: this.$t("labels.policies_list_of_files"),
          value: "policies_list_of_files",
        },
        {
          key: this.$t("labels.regulations_list_of_files"),
          value: "regulations_list_of_files",
        },
        { key: this.$t("labels.template"), value: "template" },
        {
          key: this.$t("labels.all_reports_financial_and_none_financial"),
          value: "all_reports_financial_and_non_financial",
        },
        {
          key: this.$t(
            "labels.All resolutions and minutes of the General Assembly"
          ),
          value: "all_resolutions_and_minutes_of_the_general_assembly",
        },
        {
          key: this.$t("labels.All strategic plan files"),
          value: "all_strategic_plan_files",
        },
        {
          key: this.$t("labels.All statistics and questionnaires files"),
          value: "all_statistics_and_questionnaires_files",
        },
      ],
      headers: ["file", "name", "title", "actions"],
      fileIndex: "",
      file_id: "",
      isEdit: false,
      locale: this.locale,
      reset: false,
      attachment: {},
      form: {
        title: "",
        name: "",
        attachment: {},
      },
    };
  },
  methods: {
    handelRefreshData() {
      this.$refs.table_ref.handleGetItems();
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.fileIndex = index;
      this.file_id = item.id;
      this.onToggleDialog();
      this.handleShow();
    },
    handleShow(locale = this.locale) {
      ShowData({ reqName: "files", param: this.file_id, locale }).then(
        (res) => {
          const { file } = res.data;
          this.form = file;
          this.attachment = file.attachment;
        }
      );
    },
    handleSubmit() {
      this.loading = true;
      const formData = new FormData();
      if (this.isEdit) delete this.form.attachment;
      for (const key in this.form) {
        formData.append(key, this.form[key]);
      }
      formData.append("locale", this.locale);
      if (!this.isEdit) {
        // in case create
        this.$refs.table_ref
          .handleOnCreate("files", formData, "file")
          .finally(() => (this.loading = false));
      } else {
        // in case edit
        formData.append("_method", "put");
        this.$refs.table_ref
          .handleOnEdit("files", formData, this.file_id, "file", this.fileIndex)
          .finally(() => (this.loading = false));
      }
    },
    onFileSelected(file) {
      this.form.attachment = file.file;
    },
    onLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    onDialogClose() {
      this.reset = true;
      this.isEdit = false;
      this.locale = cookie.get("language");
      this.$v.$reset();
      this.form = {
        name: "",
        title: "",
        attachment: {},
      };
      this.attachment = {};
      this.fileIndex = "";
      this.file_id = "";
      setTimeout(() => {
        this.reset = false;
      }, 500);
    },
    onToggleDialog() {
      this.$refs.table_ref.toggleDialog();
    },
  },
  computed: {
    serverErrors() {
      return this.$store.getters.serverErrors;
    },
    formTitle() {
      if (!this.isEdit) {
        // in case create
        return this.$t("heading.create");
      } else {
        // in case edit
        return this.$t("heading.edit");
      }
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      title: {
        required,
      },
      attachment: {
        required,
      },
    },
  },
};
</script>

